import { Inject } from '@angular/core';
import { AcumaticaService } from './../../acumatica/acumatica.service';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { APP_MENU_ITEMS, MenuItem } from 'src/app/app.module';
import { UpToDateBuildService } from 'src/app/services/up-to-date-build.service';

@Component({
  selector: 'app-home-dashboard',
  templateUrl: './home-dashboard.component.html',
  styleUrls: ['./home-dashboard.component.css']
})
export class HomeDashboardComponent {
  environment = environment; // make environment variables available to template

  menuItems: MenuItem[][];

  get isDevMode(): boolean { return this.isDevMode; }
  get isRepMode(): boolean { return this.environment.mode == 'rep'; }
  buildIsUpToDate: boolean = false;

  constructor(
    public acumatica: AcumaticaService,
    public upToDateService: UpToDateBuildService,
    @Inject(APP_MENU_ITEMS) _menuItems: MenuItem[]
  ) {
    // create groups (array) of menu items (array) so DOM template can add breaks before groups
    this.menuItems = [];

    let group: MenuItem[] = [];
    _menuItems.forEach(item => {
      if (item.condition && !item.condition(environment, acumatica)) return;

      if (item.loaded) item.loaded(item, acumatica);

      if (item.break && group.length > 0) {
        this.menuItems.push(group);
        group = [];
      }
      group.push(item);
    });

    if (group.length > 0) { this.menuItems.push(group); group = []; }

    upToDateService.buildIsUpToDate.subscribe(buildIsUpToDate => {
      this.buildIsUpToDate = buildIsUpToDate;
    });
  }
}